import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';

export const generateQRCode = text => {
  let url;
  let size = 1000;
  let offset = 30;
  QRCode.toCanvas(
    text,
    {
      version: 3,
      margin: 3,
      width: size,
    },
    (error, canvas) => {
      if (error) {
        throw error;
      }

      const ctx = canvas.getContext('2d');

      // outline
      const cx = offset;
      const cy = offset;
      const cw = size - offset * 2;
      const ch = size - offset * 2;
      const cr = offset * 2;
      ctx.beginPath();
      ctx.moveTo(cx * 4, cy);
      ctx.arcTo(cx + cw, cy, cx + cw, cy * 2, cr);
      ctx.arcTo(cx + cw, cy + ch, cw, cy + ch, cr);
      ctx.arcTo(cx, cy + ch, cx, ch, cr);
      ctx.arcTo(cx, cy, cx * 4, cy, cr);
      ctx.closePath();
      ctx.lineWidth = 20;
      ctx.strokeStyle = '#00D7B2';
      ctx.stroke();

      // pay text
      const tw = 360;
      const th = 120;
      const tx = size / 2 - tw / 2;
      const ty = size / 2 - th / 2;
      const tr = th / 2;
      ctx.beginPath();
      ctx.moveTo(tx + tr, ty);
      ctx.arcTo(tx + tw, ty, tx + tw, ty + th, tr);
      ctx.arcTo(tx + tw, ty + th, tx, ty + th, tr);
      ctx.arcTo(tx, ty + th, tx, ty, tr);
      ctx.arcTo(tx, ty, tx + tw, ty, tr);
      ctx.closePath();
      ctx.lineWidth = 30;
      ctx.strokeStyle = '#ffffff';
      ctx.stroke();
      ctx.fillStyle = '#00D7B2';
      ctx.fill();
      ctx.font = '65px rubik';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#000000';
      ctx.fillText('Autopass', size / 2, size / 2);

      url = canvas.toDataURL('image/png');
    }
  );
  return url;
};

export const generateBarCode = (code, options = {}) => {
  if (!code) return '';
  var canvas = document.createElement('canvas');
  JsBarcode(canvas, code, {
    width: 14,
    height: 400,
    fontSize: 100,
    displayValue: false,
    ...options,
  });
  return canvas.toDataURL('image/png');
};

export const generateScanCode = text => {
  return Promise.all([generateBarCode(text), generateQRCode(text)])
    .then(value => {
      return {
        barcode: value[0],
        qrcode: value[1],
      };
    })
    .catch(error => {
      return { error };
    });
};
